/**
 * Fixing post messages that has the delimiters as part of the message
 *  -- like API Key string, PANJW string
 * @param {string} acc action
 * @param {string} str first incomplete json string
 * @param {object} data remaining broken json string
 * @param {string} delim delimiter
 * @returns {object} cleaned object
 */
function fixMessage(acc, str, data, delim) {
  if (data.length <= 0) {
    if (str) {
      return acc.concat(str);
    }
    return acc;
  }
  const head = data[0];
  const tail = data.slice(1);
  // If JSON invalid, merge with the next string until JSON is valid
  try {
    JSON.parse(str);
    return fixMessage(acc.concat(str), head, tail, delim);
  } catch (err) {
    // Merge string with delimiter
    return fixMessage(acc, str + delim + head, tail, delim);
  }
}

export default fixMessage;
